import { graphql } from '@/generated/gql';

export const INTAKE_STATEMENT_OF_WORK_UPSERT_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeStatementsOfWorkUpsertMutation($data: SvbrgStatementOfWorkUpsertInput!) {
    sevenbridges {
      chatSession {
        statementOfWork {
          upsert(data: $data) {
            id
            text
            language
          }
        }
      }
    }
  }
`);

export const INTAKE_STATEMENT_OF_WORK_NEXT_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeStatementsOfWorkNextMutation($data: SvbrgStatementOfWorkNextInput!) {
    sevenbridges {
      chatSession {
        statementOfWork {
          next(data: $data)
        }
      }
    }
  }
`);
